import { PropTypes } from 'prop-types';
import { Checkbox } from 'components/UI/Checkbox/Checkbox';
import './SearchModalCheckboxes.scss';

export const SearchModalCheckboxes = (props) => {
  const {
    searchFilters,
    selectedCheckboxes,
    setSelectedCheckboxes,
    setApplyFiltersButtonDisabled,
  } = props;

  const checkboxChangeHandler = (event, checkboxId) => {
    const checkboxIsChecked = event.target.checked;
    if (checkboxIsChecked) {
      setSelectedCheckboxes([...selectedCheckboxes, checkboxId]);
    } else {
      const updatedSelectedCheckboxes = selectedCheckboxes.filter(
        (searchFilterId) => checkboxId !== searchFilterId
      );
      setSelectedCheckboxes(updatedSelectedCheckboxes);
    }

    setApplyFiltersButtonDisabled(false);
  };

  const listItems = searchFilters?.map(({ id, description, enabled }, index) => {
    const isChecked = selectedCheckboxes.includes(id);

    return enabled ? (
      <li key={index} data-testid="search-filters-list-item">
        <Checkbox
          label={description}
          value={id}
          isChecked={isChecked}
          checkboxChangeHandler={(event) => checkboxChangeHandler(event, id)}
        />
      </li>
    ) : null;
  });

  return (
    <ul className="search-filters" data-testid="search-filters-list">
      {listItems}
    </ul>
  );
};

SearchModalCheckboxes.propTypes = {
  searchFilters: PropTypes.arrayOf(PropTypes.object),
  selectedCheckboxes: PropTypes.array,
  setSelectedCheckboxes: PropTypes.func,
  setApplyFiltersButtonDisabled: PropTypes.func,
};
